/*
* Copyright (C) Regione Lombardia
*/
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from '@env/environment';
import {
    RequestUtenteRichiestaProfilo,
    RequestUtenteSearch,
    ResponseGenericoBoolean,
    ResponseUtente,
    RuoloEnum,
    Utente,
    UtenteSession,
    UtenteStatusEnum
} from '@models';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class UtenteService {

    public redirectUrl: string = '';
    
    private _logged: boolean = false;
    get logged() { return this._logged; }
    set logged(logged: boolean) { this._logged = logged; }

    private _utente: Utente;
    get utente() { return this._utente; }
    set utente(utente: Utente) { this._utente = utente; }

    constructor(
        private httpClient: HttpClient,
        private fb: FormBuilder,
    ) { }

    /* Form: group */
    public generateFormUtente(values?: Utente | UtenteSession, removeValidators?: boolean): FormGroup {
        const criteriaForm =  this.fb.group({
            id: this.fb.control(null),
            cognome: this.fb.control(null, removeValidators ?  null : Validators.required),
            nome: this.fb.control(null, removeValidators ?  null : Validators.required),
            codiceFiscale: this.fb.control(null, removeValidators ?  null : Validators.required),
            email: this.fb.control(null, removeValidators ? null : [Validators.required, Validators.email]),
            emailIstituzionale: this.fb.control(null, removeValidators ? null : [Validators.required, Validators.email]),
            ente: this.fb.control(null, removeValidators ?  null : Validators.required),
            ruolo: this.fb.control(null, removeValidators ?  null : Validators.required),
            status: this.fb.control(null)
        });
        if (values) {
            criteriaForm.patchValue(values);
        }
        return criteriaForm;
    }

    /* Autenticazione */
    public check(): Observable<ResponseGenericoBoolean> {
        return this.httpClient.get<ResponseGenericoBoolean>(`${environment.urlApi}/private/utente/check`);
    }
    public auth(): Observable<any> {
        return this.httpClient.get<any>(`${environment.urlApi}/private/auth`);
    }
    public getByHeader(): Observable<Utente> {
        return this.httpClient.get<Utente>(`${environment.urlApi}/private/utente`);
    }
    public logout(): Observable<ResponseGenericoBoolean> {
        return this.httpClient.get<ResponseGenericoBoolean>(`${environment.urlApi}/private/auth/logout-custom`);
    }
    /* CRUD */
    public update(params: Utente): Observable<Utente> {
        return this.httpClient.put<Utente>(`${environment.urlApi}/private/utente`, params);
    }

    /* Profilazione */
    public getFromSession(): Observable<UtenteSession> {
        return this.httpClient.get<UtenteSession>(`${environment.urlApi}/private/utente/session`);
    }
    public richiestaProfilo(params: RequestUtenteRichiestaProfilo) {
        return this.httpClient.post(`${environment.urlApi}/private/utente/richiesta-profilo`, params, { observe: 'response' });
    }
    public updateRichiestaProfilo(params: RequestUtenteRichiestaProfilo) {
        return this.httpClient.put(`${environment.urlApi}/private/utente/update`, params, { observe: 'response' });
    }

    /* Amministrazione */
    public getInApprovazione(paginatorQueryParams: string): Observable<ResponseUtente> {
        return this.httpClient.get<ResponseUtente>(`${environment.urlApi}/private/utente/in-approvazione?${paginatorQueryParams}`);
    }
    public validazione(azione: string, id: number) {
        return this.httpClient.put(`${environment.urlApi}/private/utente/${id}/validazione/${azione}`, null, { observe: 'response' });
    }
    public search(values: RequestUtenteSearch, paginatorQueryParams: string): Observable<ResponseUtente> {
        return this.httpClient.post<ResponseUtente>(`${environment.urlApi}/private/utente/ricerca?${paginatorQueryParams}`, values);
    }

    /* Metodi di controllo */
    public isEnabled(): boolean {
        return this.utente && this.utente.status.toString() === UtenteStatusEnum.COMPLETED.toString();
    }
    public isRuoloAmministratore(): boolean {
        return this.utente?.ruolo.toString() === RuoloEnum.AMMINISTRATORE.toString();
    }
    public isRuoloOperatore(): boolean {
        return this.utente?.ruolo.toString() === RuoloEnum.OPERATORE.toString();
    }
    public isRuoloConsultatore(): boolean {
        return this.utente?.ruolo.toString() === RuoloEnum.CONSULTATORE.toString();
    }

}
